// extracted by mini-css-extract-plugin
export var downArrow = "_b1-0";
export var label = "_b1-1";
export var treatmentCard = "_b1-3";
export var upArrow = "_b1-2";